import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import vi from "./locales/vi/translation.json";

export const resources = {
  en: { translation: en },
  vi: { translation: vi },
};

i18n
  // Detect user language (localStorage → navigator, etc.)
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: "vi",
    fallbackLng: "vi",
    supportedLngs: ["en", "vi"],
    interpolation: {
      // React already escapes values to prevent XSS
      escapeValue: false,
    },
    detection: {
      // Order of language detection; persist choice in localStorage
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
